<template>
  <main-menu-bar>
    <b-navbar-nav>
      <router-link
        :id="route.name+'-main-link'"
        class="nav-link"
        v-for="route in routes"
        :key="route.name"
        :to="route.path ? route.path : '/'">{{route.label}}</router-link>
    </b-navbar-nav>

    <user-menu class="ml-auto">
      <b-dropdown-item href="/guide/me">Minha Conta</b-dropdown-item>
      <b-dropdown-divider/>
    </user-menu>

  </main-menu-bar>

</template>

<script>
import MainMenuBar from './MainMenuBar';
import UserMenu from './UserMenu';
import { homeChildrenPath } from "../../../routes";

export default {
	components: { MainMenuBar, UserMenu },
  data() {
    return {
      routes: homeChildrenPath.filter(route => route.menu),
      user: {}
    };
  },
  created() {
    this.loadUserInfo();
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    loadUserInfo() {
      if (!this.$store.getters.user.email) this.$store.dispatch("loadUserInfo");
      this.user = this.$store.getters.user;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/main-menu/MainMenu.vue